/* Specific JS needed just for header that eArcu uses */

"use strict";

////////////////////////////////////////////////
// START -  mobile nav toggle JS
var navbarToggler = document.querySelector('.navbar-toggler');
var navbarBg = document.querySelector( '.navbar-bg' );
var navBar = document.querySelector( '.navbar' );
var ariaExpanded = navbarToggler.getAttribute( 'aria-expanded' ); 

navbarToggler.addEventListener( 'click' , function() {

    navBar.classList.toggle( 'is-active' );

    if (ariaExpanded == 'true' ) {
        ariaExpanded = 'false'
    } else {
        ariaExpanded = 'true'
    }
    navbarToggler.setAttribute( 'aria-expanded' , ariaExpanded);
});
// END - mobile nav toggle JS
///////////////////////////////////////////////

////////////////////////////////////////////////
// START - remove load class from body
window.addEventListener('load', function() {
    document.body.classList.remove('page-loading');
});
// END - only show focus ring on tab not click
///////////////////////////////////////////////

////////////////////////////////////////////////
// START - only show focus ring on tab not click
function handleFirstTab(e) {
    if (e.keyCode === 9) {
        document.body.classList.add('user-is-tabbing');
        window.removeEventListener('keydown', handleFirstTab);
        window.addEventListener('mousedown', handleMouseDownOnce);
    }
}

function handleMouseDownOnce() {
    document.body.classList.remove('user-is-tabbing');
    window.removeEventListener('mousedown', handleMouseDownOnce);
    window.addEventListener('keydown', handleFirstTab);
}

window.addEventListener('keydown', handleFirstTab);
// END - only show focus ring on tab not click
///////////////////////////////////////////////

////////////////////////////////////////////////////////
// START - hide nav on scroll down and show on scroll up
document.addEventListener('DOMContentLoaded', function () {
    let lastScrollTop = 0;
    const delta = 5;
    const header = document.querySelector('.header');
    const body = document.body;

    window.addEventListener('scroll', function () {
        const nowScrollTop = window.scrollY || document.documentElement.scrollTop;

        // Check if the user scrolled more than the delta
        if (Math.abs(lastScrollTop - nowScrollTop) > delta) {
            if (nowScrollTop > lastScrollTop) {
                // Scrolling down
                header.classList.add('header-hide');
                header.classList.remove('header-show');
                body.classList.add('header-hide');
                body.classList.remove('header-show');
            } else {
                // Scrolling up
                header.classList.remove('header-hide');
                header.classList.add('header-show');
                body.classList.remove('header-hide');
                body.classList.add('header-show');
            }
            // Update the last scroll position
            lastScrollTop = nowScrollTop;
        }
    });
});
// END - hide nav on scroll down and show on scroll up
//////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////
// START - keep menu transparent until scroll goes above 86px
window.addEventListener('load', checkScroll);
window.addEventListener('scroll', checkScroll);

function checkScroll() {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const body = document.body;
    const html = document.documentElement;

    if (scrollTop > 86) {
        html.classList.add('nav-bg-color');
        body.classList.add('nav-bg-color');
    } else {
        html.classList.remove('nav-bg-color');
        body.classList.remove('nav-bg-color');
    }
}
// END - keep menu transparent until scroll goes above 86px
/////////////////////////////////////////////////////////////
